module.exports = __webpack_public_path__ + "img/mobile scanner stand-07.d793a45f.png";